module.exports = "//public.getcloudapp.com/packs/media/images/logo@2x-blue-159e6dadf37f9a7fc9d20f58acb46006.png";